import { render, staticRenderFns } from "./tplDivider.vue?vue&type=template&id=76215e31&scoped=true&"
import script from "./tplDivider.vue?vue&type=script&lang=js&"
export * from "./tplDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76215e31",
  null
  
)

export default component.exports